import { DeleteGallery, FetchGalleries } from "../../redux/gallery";
import { Grid, Section } from "../../components/section";
import { IoAddCircleOutline, IoPencilOutline, IoTrash } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { AppLinks } from "../../components/links";
import { Cards } from "../../components/cards";
import { ErrorBanner } from "../../components/banner";
import { Link } from "react-router-dom";
import { Loading } from "../../components/loader";
import { PageHeader } from "../../components/header";
import { PhotoDetailFetch } from "./PhotoDetailFetch";
import img from "../../assets/imgs/cford.webp";
import styled from "styled-components";

export const PhotoList = () => {
  const [open, SetOpen] = useState(false);
  const [selected, SetSelected] = useState({});

  const dispatch = useDispatch();
  const { loading, error, galleries, isDownloading, downloadProgress } =
    useSelector((state) => state.gallery);

  const onToggleOpenClose = () => {
    SetOpen(!open);
  };

  const onDisplayImages = (data) => {
    onToggleOpenClose();
    SetSelected(data);
  };

  const onRemoveDisplayImage = () => {
    onToggleOpenClose();
    SetSelected({});
  };

  const onDeleteSubmit = (value) => {
    if (window.confirm("Are you sure you want to delete this?")) {
      dispatch(DeleteGallery(value));
      onToggleOpenClose();
    }
  };

  useEffect(() => {
    dispatch(FetchGalleries());
  }, [dispatch]);

  if (loading || isDownloading) {
    return <Loading progress={downloadProgress} />;
  }

  return (
    <div>
      <PgContainer title="Images">
        <Link to={`/gallery/photos/create`}>
          <IoAddCircleOutline />
        </Link>
      </PgContainer>

      {error && <ErrorBanner text={error} />}

      <BaseGalleryList>
        <Grid col="3">
          {galleries &&
            galleries?.map((s, i) => {
              return (
                <>
                  <Cards
                    key={s.id}
                    title={s?.title}
                    description={s?.description}
                    image={
                      s?.media && s?.media?.mediaFiles
                        ? s?.media?.mediaFiles[0]?.url
                        : img
                    }
                    imageDescription={`${s.title} image ${i + 1}`}
                    onClick={() => onDisplayImages(s)}
                  />
                </>
              );
            })}
        </Grid>
      </BaseGalleryList>
      <PhotoDetailFetch
        images={selected?.media?.mediaFiles}
        title={selected?.title}
        open={open}
        onToggleOpenClose={onRemoveDisplayImage}
        components={
          <div>
            <IoTrash onClick={() => onDeleteSubmit(selected)} />
            <AppLinks
              to={`/gallery/photos/${selected.id}/edit`}
              state={{ gallery: selected }}
            >
              <IoPencilOutline />
            </AppLinks>
          </div>
        }
      />
    </div>
  );
};

export default PhotoList;

const BaseGalleryList = styled(Section)`
  padding-top: 0rem;
`;

const PgContainer = styled(PageHeader)`
  padding: 0;
  display: flex;
`;
